/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("react"),o=t.createContext([null,e=>{}]),n=t.createContext([null,e=>{}]),i=t.createContext([null,e=>{}]);exports.ChipListDataContext=i;exports.ChipListFocusContext=n;exports.ChipListSelectionContext=o;
